export default __webpack_public_path__ + "static/media/food-tour.bf4bc3c3.jpg";